(function () {
	window.addEventListener("DOMContentLoaded", (event) => {
		// const videos = document.querySelectorAll('.js-video-comparison__video');
		// const html = document.querySelector('html');
		// const safari = html.classList.contains('is-safari');
		// const iphone = html.classList.contains('is-iphone');
		// const ipad = html.classList.contains('is-ipad');
		// const android = html.classList.contains('is-android');
		// const mac = html.classList.contains('is-macintosh');

		// if (iphone || ipad || android) {
		// 	Array.prototype.forEach.call(videos, function(video, index) {
		// 		video.addEventListener('click', function() {
		// 			if (this.paused) {
		// 				this.play();
		// 				this.nextElementSibling.classList.remove("paused");
		// 			} else {
		// 				this.pause();
		// 				this.nextElementSibling.classList.add("paused");
		// 			}
		// 		});
		// 	})
		// } else {
		// 	Array.prototype.forEach.call(videos, function(video, index) {
		// 		video.addEventListener('click', function() {
		// 				if (video.paused) {
		// 						this.nextElementSibling.classList.remove("paused");
		// 				} else {
		// 						this.nextElementSibling.classList.add("paused");
		// 				}
		// 		});
		// 	})
		// }
	});
})();